import classNames from 'classnames'
import React from 'react'
import {connect} from 'react-redux'

import {Dispatch} from 'redux'
import * as mobileMenuActions from '../../actions/mobileMenu'
import * as mobileMenuSelectors from '../../store/mobileMenu'
import {RootState} from '../../store/types'

import AutoLink from '../AutoLink'
import ZeroHeight from '../ZeroHeight'

import * as track from '../../track/track'
import * as URLS from '../../urls'

interface MobileNavAccordionProps {
  data: {
    links: {
      title: string
      toSpa: boolean
      url: string
      target: string
    }[]
    hasDivider: boolean
    marketingText: string
    title: string
    toSpa: boolean
    url: string
    target: string
  }
  isOpen: boolean
  toggle: () => void
}

const MobileNavAccordion: React.FC<MobileNavAccordionProps> = ({
  data: {links, title, toSpa, url, marketingText, hasDivider, target},
  isOpen,
  toggle,
}) => (
  <section
    className={classNames('mobile-nav-accordion', {
      'is--open': isOpen,
    })}
  >
    {url ? (
      <AutoLink
        className="mobile-nav-accordion-toggle"
        isToSpa={toSpa}
        to={url}
        target={target}
        onClick={() => {
          if (url === URLS.SHOWROOMS) {
            track.headerLocationsLinkClicked()
          }
          track.headerNavClicked(title, url)
        }}
      >
        <h3 className="mobile-nav-accordion-title">{title}</h3>
      </AutoLink>
    ) : (
      <div>
        <button
          className={classNames('mobile-nav-accordion-toggle', {
            'mobile-nav-accordion--has-divider': hasDivider,
          })}
          onClick={toggle}
        >
          <h3 className="mobile-nav-accordion-title">{title}</h3>
          <svg className="mobile-nav-accordion-toggle-icon">
            <use xlinkHref="#icon-nav-chevron" />
          </svg>
        </button>
        <ZeroHeight className="mobile-nav-accordion-content" isOpen={isOpen}>
          {marketingText && (
            <div className="accordion-content-header">
              <em>{marketingText}</em>
            </div>
          )}
          <ul className="mobile-nav-accordion-links">
            {links.map((link) => (
              <li key={link.title} className="mobile-nav-accordion-link-item">
                <AutoLink
                  className="mobile-nav-accordion-link"
                  isToSpa={link.toSpa}
                  target={link.target}
                  to={link.url}
                  onClick={() => track.headerNavClicked(link.title, link.url)}
                >
                  {link.title}
                </AutoLink>
              </li>
            ))}
          </ul>
        </ZeroHeight>
      </div>
    )}
  </section>
)

const mapStateToProps = (state: RootState, {data: {title}}: MobileNavAccordionProps) => ({
  isOpen: mobileMenuSelectors.isAccordionOpen(state, title),
})

const mapDispatchToProps = (dispatch: Dispatch, {data: {title}}: MobileNavAccordionProps) => ({
  toggle: () => dispatch(mobileMenuActions.toggleMobileMenuAccordion(title)),
})

export default connect(mapStateToProps, mapDispatchToProps)(MobileNavAccordion)
